import {
  GET_QUESTIONNAIRE_DETAIL,
  GET_QUESTIONNAIRE_DETAIL_SUCCESS,
  GET_QUESTIONNAIRE_DETAIL_FAILURE,
} from 'store/getQestionnaireDetail/getQuestionnaireDetailAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getQuestionnaireDetailData = (state = initialState, action) => {
  switch (action.type) {
    case GET_QUESTIONNAIRE_DETAIL:
      return { ...state, loading: true };
    case GET_QUESTIONNAIRE_DETAIL_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_QUESTIONNAIRE_DETAIL_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getQuestionnaireDetailData;
